/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiLoadSpinnerIcon16Regular = forwardRef('UiLoadSpinnerIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 2.75A5.25 5.25 0 1 0 13.25 8a.75.75 0 0 1 1.5 0A6.75 6.75 0 1 1 8 1.25a.75.75 0 0 1 0 1.5Z" })));
});
